'use client';

import { useSearchParams } from 'next/navigation';
import { PropsWithChildren } from 'react';

import { InventoryContext } from '@/contexts/InventoryContext';
import { InventoryProvider } from '@lamesarv-sdk/inventory';
import { getFiltersFromSearchParams } from '@lamesarv-sdk/tools';

interface WrappedInventoryProviderProps {
  noPriceButtonContent?: string;
}

export const WrappedInventoryProvider = (props: PropsWithChildren<WrappedInventoryProviderProps>) => {
  const searchParams = useSearchParams();
  const searchDto = getFiltersFromSearchParams(searchParams, false);

  return (
    <InventoryProvider {...searchDto} clientContext={InventoryContext}>
      {props.children}
    </InventoryProvider>
  );
};
